export interface ResponseModel {
  msg: string;
  data?: any;
}

export interface UploadImageResponse {
  success: boolean;
  error?: any;
  url?: string;
}

export enum ComponentType {
  MATERIAL = "MATERIAL",
  CONTRACTOR = "CONTRACTOR"
}

export enum OrderStatusEnum {
  NOT_SENT = "NOT_SENT",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  UNCONFIRMED = "UNCONFIRMED"
}

export interface ProjectProductSystemOrderStatusInput {
  projectId: number;
  productSystemId: number;
  componentType: ComponentType;
  orderStatus: OrderStatusEnum;
  supplierId?: number;
  jobStartDate?: string;
  installationDate?: string;
  removalDate?: string;
  attachmentFileIds?: number[];
  source?: string;
}
